import script from "./FirmCuraprox.vue?vue&type=script&lang=ts&setup=true"
export * from "./FirmCuraprox.vue?vue&type=script&lang=ts&setup=true"

import "./FirmCuraprox.vue?vue&type=style&index=0&id=08709086&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08709086"]])

export default __exports__